const d = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let a = 0, r;
  for (; a < n; )
    r = a + t, yield e.slice(a, r), a = r;
}, h = async function* (e, t) {
  for await (const n of w(e))
    yield* d(n, t);
}, w = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: a } = await t.read();
      if (n)
        break;
      yield a;
    }
  } finally {
    await t.cancel();
  }
}, b = (e, t, n, a) => {
  const r = h(e, t);
  let y = 0, o, c = (i) => {
    o || (o = !0, a && a(i));
  };
  return new ReadableStream({
    async pull(i) {
      try {
        const { done: l, value: s } = await r.next();
        if (l) {
          c(), i.close();
          return;
        }
        let u = s.byteLength;
        if (n) {
          let f = y += u;
          n(f);
        }
        i.enqueue(new Uint8Array(s));
      } catch (l) {
        throw c(l), l;
      }
    },
    cancel(i) {
      return c(i), r.return();
    }
  }, {
    highWaterMark: 2
  });
};
export {
  h as readBytes,
  d as streamChunk,
  b as trackStream
};
//# sourceMappingURL=index.es359.js.map
